import { useDispatch, useSelector } from "react-redux";
import { setThemeSettings } from "../core/data/redux/commonSlice";

import { Outlet } from "react-router";
import AgentSidebar from "../core/common/agent-sidebar";
import AgentHeader from "../core/common/agent-header";
import ThemeSettings from "../core/common/theme-settings/themeSettings";
import LoggedInElsewhereModal from "./common/LoggedInElsewhereModal";

// Global flag to track OneSignal initializationx

const AdminFeature = () => {
  const dispatch = useDispatch();
  const themeOpen = useSelector((state) => state?.common?.themeSettings);
  const headerCollapse = useSelector((state) => state?.common.headerCollapse);
  const mobileSidebar = useSelector((state) => state?.common?.mobileSidebar);
  const miniSidebar = useSelector((state) => state?.common?.miniSidebar);
  const expandMenu = useSelector((state) => state?.common?.expandMenu);

  // Use OneSignal auth hook for user login/logout

  return (
    <div
      className={`
      ${miniSidebar ? "mini-sidebar" : ""}
      ${expandMenu ? "expand-menu" : ""}`}
    >
      <div
        className={`main-wrapper 
        ${headerCollapse ? "header-collapse" : ""} 
        ${mobileSidebar ? "slide-nav" : ""}`}
        style={{ maxWidth: "100vw", overflowX: "hidden" }}
      >
        <AgentHeader />
        <AgentSidebar />
        <Outlet />
        {/* <ThemeSettings/> */}
        <LoggedInElsewhereModal />
      </div>
      <div className="sidebar-overlay"></div>
      <div
        className={`sidebar-themeoverlay ${themeOpen ? "open" : ""}`}
        onClick={() => dispatch(setThemeSettings(!themeOpen))}
      ></div>
    </div>
  );
};

export default AdminFeature;
